import "./sentry-initialization";
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import * as Sentry from "@sentry/react";
import './assets/styles/main.css'
import App from './components/app/App'
import store from './store'
import ErrorPage from "./components/error-page";
import { get } from "lodash";

let reloadTriggered = false;

function safeReload(reason) {
  if (reloadTriggered) return;

  reloadTriggered = true;
  console.warn(`[AutoReload] Triggered by: ${reason}.`);

  setTimeout(() => {
    window.location.reload(true);
  }, 1000);
}

function isChunkLoadError(msg) {
  return (
    msg.includes('ChunkLoadError') ||
    msg.includes('Loading chunk') ||
    msg.includes("Unexpected token '<'")
  );
}

window.onerror = function (message) {
  const msg = String(message || '');
  if (isChunkLoadError(msg)) {
    safeReload('window.onerror');
  }
};

window.onunhandledrejection = function (event) {
  const reason = String(get(event, "reason.message", ""));
  if (isChunkLoadError(reason)) {
    safeReload('window.onunhandledrejection');
  }
};

createRoot(document.getElementById('root')).render(
  <Sentry.ErrorBoundary fallback={<Router><ErrorPage /></Router>}>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </Sentry.ErrorBoundary>
)
